import * as React from "react";
import {Option} from "ts-option";
import Col from "../../layout/Col";
import TextArea from "../../../hiberUiKit/src/atoms/TextArea/TextArea";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface ComponentProps {
	/**
	 * Update custom field value action.
	 * @param {string} updatedValue
	 */
	updateCustomFieldValue: (updatedValue: string) => void;
	/**
	 * Custom field label
	 */
	label: string;
	/**
	 * Custom field value
	 */
	value: Option<string>;
}

interface IState {
	/**
	 * Temporary custom field value
	 */
	tmpValue: string;
}

export default class StringInFormDisplay extends React.Component<ComponentProps, IState> {

	constructor(props: ComponentProps) {
		super(props);
		this.state = {tmpValue: this.props.value.getOrElse('')};
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<Col md={12} lg={4} xl={4} style={{paddingBottom: '30px'}}>
				<FormGroup label={this.props.label}>
					<TextArea onChange={this.onChange}
							  hasBorder={true}
							  value={this.state.tmpValue}
							  rows={5}/>
				</FormGroup>
			</Col>
		);
	}

	private onChange(evt: React.ChangeEvent<HTMLTextAreaElement>) {
		this.setState({tmpValue: evt.target.value}, () => this.props.updateCustomFieldValue(this.state.tmpValue));
	}
}